module.exports = __webpack_public_path__ + "static/media/triangle.70cb2b46.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/form/Type/triangle.svg
 ** module id = 197
 ** module chunks = 0
 **/